import PropTypes from 'prop-types';
import React from 'react';

import { CodeSnippet } from '$partials/global';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @component Embed
 * @props (see propTypes)
 */
const Embed = ({ code = '' }) => {
    return (
        <section className='module-embed'>
            <div className='pr-gutter mxn-gutter'> {/* outer grid gutter */}
                <div className='flex flex-wrap'>
                    {/* side title */}
                    <div className='absolute top-0 md-relative md-col-2' />

                    {/* content */}
                    <div className='col-12 sm-col-12 md-col-10'>
                        <div className='ml9 sm-ml9 md-ml0'>
                            <div className='px-gutter'>
                                <CodeSnippet html={code}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    code: PropTypes.string.isRequired
};

Embed.propTypes = propTypes;

export { Embed };

export default Embed;
